module.exports = __webpack_public_path__ + "img/5.bc81afa8.png";